import React from "react";

import { Index } from "../components/Contact/Index";

export const Contact = () => {
  return <Index />;
};
